import AddGame from './AddGame'
export default AddGame